import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import primaryComponents from "../../primaryComponents";

const JournalOptionsDropdown = ({
  copyJournalEntry,
  copyJournalEntryMutation,
  voidJournalEntry,
  voidJournalEntryMutation,
  journalEntryDetails,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const menuOption = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!menuOption.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <div style={{ position: "relative", zIndex: 2 }} ref={menuOption}>
        <primaryComponents.Button
          onClick={() => setShowDropdown(!showDropdown)}
          classNames="btn btn--primary"
        >
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon="angle-down" style={{ fontSize: "18px" }} />
            <span className="default-text-size pl-2">Journal Options</span>
          </div>
        </primaryComponents.Button>
        {showDropdown ? (
          <motion.div
            initial={{ y: -10 }}
            animate={{ y: 0 }}
            className={styles.dropdown}
          >
            <p
              className={`dark--text ${copyJournalEntryMutation.isLoading ? "disabled" : ""}`}
              onClick={copyJournalEntry}
            >
              {copyJournalEntryMutation.isLoading
                ? "Copying..."
                : "Copy Journal Entry"}
            </p>
            {journalEntryDetails?.status === "POSTED" && (
              <p
                className={`dark--text ${voidJournalEntryMutation.isLoading ? "disabled" : ""}`}
                onClick={voidJournalEntry}
              >
                {voidJournalEntryMutation.isLoading
                  ? "Voiding..."
                  : "Void Journal Entry"}
              </p>
            )}
          </motion.div>
        ) : null}
      </div>
    </>
  );
};

export default JournalOptionsDropdown;
